<script lang="ts">export let fill = "white";
</script>

<svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M8.00045 7.05779L11.3003 3.75793L12.2431 4.70074L8.94325 8.00059L12.2431 11.3004L11.3003 12.2432L8.00045 8.94339L4.70063 12.2432L3.75781 11.3004L7.05765 8.00059L3.75781 4.70074L4.70063 3.75793L8.00045 7.05779Z"
		{fill}
	/>
</svg>
